// 男/女仍用打包资源；缺头像与「其他」性别用 public 下 SVG，避免空 src 裂图且路径稳定
import boyJpeg from './boy.jpeg';
import girlJpeg from './girl.jpeg';

export const defaultAvatarBoy = boyJpeg;
export const defaultAvatarGirl = girlJpeg;
export const defaultAvatar = '/default-avatar.svg';

export function getDefaultAvatarByGender(gender?: string): string {
  if (gender === '男') return defaultAvatarBoy;
  if (gender === '女') return defaultAvatarGirl;
  return defaultAvatar;
}
